import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "Events", path: "/events" },
  { name: "VIP", path: "/vip" },
  { name: "Gallery", path: "/gallery" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];

const LOGO_URL = "https://customer-assets.emergentagent.com/job_purples/artifacts/0x3gbqfe_Final%20Logo%20White%20%281%29.png";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setIsOpen(false), [location]);

  return (
    <nav data-testid="navbar" className="relative z-50 pt-6 pb-4">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Mobile: Left burger + Center logo */}
        <div className="lg:hidden flex items-center justify-between">
          <button
            data-testid="mobile-menu-toggle"
            className="p-2 text-white"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
            <img src={LOGO_URL} alt="RROV" className="h-12 w-auto" />
            <span className="font-syne text-sm font-medium tracking-[0.25em] text-white/90">GOA</span>
          </Link>

          <div className="w-10" />
        </div>

        {/* Desktop: Centered logo + Nav below */}
        <div className="hidden lg:block">
          <div className="flex justify-center mb-6">
            <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
              <img src={LOGO_URL} alt="RROV" className="h-20 w-auto" />
              <span className="font-syne text-lg font-medium tracking-[0.25em] text-white/90">GOA</span>
            </Link>
          </div>

          <div className="flex items-center justify-center gap-12">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                data-testid={`nav-${link.name.toLowerCase()}`}
                className="text-sm font-semibold uppercase text-white/90 hover:text-white transition-colors tracking-[0.15em]"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden mt-4 mx-6 panel-light rounded-md"
          >
            <div className="px-6 py-6 space-y-4">
              {navLinks.map((link) => (
                <Link key={link.name} to={link.path} className="block text-base font-medium text-[#2D1810]">
                  {link.name}
                </Link>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};
